import angular from "angular";
import AdminStudentViewController from "./admin-view-student.controller";
import template from "./admin-view-student.html";
import homeTemplate from "./admin-view-student-home.html";
import Fees from "./fees/admin-student-fees.module";
import Orders from "./orders/student-orders.module";
import Tasks from "./tasks/tasks.module";
import Emails from "./emails/emails.module";
import CreateOrder from "./create-order/create-order.module";
import Requirements from "./lesson-plan-requirements/lesson-plan-requirements.module";
import Roadmaps from "./roadmaps/student-roadmaps.module";
import Classes from "./classes/classes.module";
import Instructors from "./instructors/instructors.module";
import Cancelations from "./cancelations/admin-view-student-cancelations.module";
import DriveDeadline from "./drive-deadline/drive-deadline.module";
import Certificate from "./certificate/certificate.module";
import OnlineDriversEd from "./online-drivers-ed/online-drivers-ed.module";
import StudentPaymentMethods from "./payment-methods/payment-methods.module";
import StudentNotes from "./notes/notes.module";
import EditStudentNote from "./edit-note/edit-note.module";
import PickupLocations from "./pickup-locations/admin-student-pick-up-locations.module";
import Documents from "./documents/admin-student-documents.module";

function getBalance(UsersModel, $stateParams) {
  return UsersModel.getStudentBalance($stateParams.userId).then((response) => {
    return response.balance;
  });
}
getBalance.$inject = ["UsersModel", "$stateParams"];

// This ui-router version (0.2.x) has no `redirectTo`, and doesn't reliably
// auto-resolve a same-url child state ("drivecoach.admin.students.view.index"
// below) for transitions that target this parent state BY NAME -- which is
// how every existing ui-sref/$state.go("drivecoach.admin.students.view", ...)
// call site in the app (25+ of them: students index, orders, reminders,
// agenda, etc.) reaches this page. Only raw URL navigation resolved it
// reliably. So redirect explicitly whenever this state itself -- not a
// deeper child like .fees/.edit -- ends up as the transition's actual
// target, rather than changing every call site to target `.index`.
//
// This can't be done in an onEnter hook: onEnter fires for this state
// whenever it's entered as an ANCESTOR too (e.g. navigating to `.fees` with
// `ui-sref-opts="{reload: true}"` re-enters this parent), and `$state.current`
// isn't reliably updated to the real final target yet at that point -- it can
// still read as this parent's own name mid-transition, causing a false-
// positive redirect back to `.index` that clobbers navigation to `.fees`/etc.
// `$stateChangeStart`'s `toState` argument is the actual requested target,
// unambiguous regardless of when `$state.current` itself updates.
function redirectParentToIndex($rootScope, $state) {
  $rootScope.$on(
    "$stateChangeStart",
    (event, toState, toParams, fromState, fromParams, options) => {
      if (toState.name !== "drivecoach.admin.students.view") {
        return;
      }
      event.preventDefault();
      $state.go("drivecoach.admin.students.view.index", toParams, {
        location: "replace",
        reload:
          options && options.reload ? "drivecoach.admin.students.view" : false,
      });
    },
  );
}
redirectParentToIndex.$inject = ["$rootScope", "$state"];

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.students.view", {
    url: "/view/:userId",
    controller: AdminStudentViewController,
    controllerAs: "vm",
    template: template,
    resolve: {
      balance: getBalance,
    },
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });

  // The Home content lives in its own index child state rather than as
  // ui-view fallback content on the parent. ngVue components (drive-deadline,
  // dc-student-progress-overview) inside ui-view fallback content get
  // re-linked and orphaned when a real child state (.fees, .edit, etc.)
  // takes over the view, breaking the transition. No controller here: the
  // view prototypally inherits `vm` from the parent state's controller,
  // same as the sidebar nav already does.
  $stateProvider.state("drivecoach.admin.students.view.index", {
    url: "",
    template: homeTemplate,
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.students.view", [
    Fees.name,
    Orders.name,
    CreateOrder.name,
    Tasks.name,
    Emails.name,
    Requirements.name,
    Roadmaps.name,
    Classes.name,
    Instructors.name,
    Cancelations.name,
    DriveDeadline.name,
    Certificate.name,
    OnlineDriversEd.name,
    StudentPaymentMethods.name,
    StudentNotes.name,
    EditStudentNote.name,
    PickupLocations.name,
    Documents.name,
  ])
  .config(config)
  .run(redirectParentToIndex)
  .controller("AdminStudentViewController", AdminStudentViewController);
